<template>
  <div class="uk-container">
    <component :is="$store.getters['account/type']" />
  </div>
</template>

<script>
import Admin from '@/components/dashboard/Admin.vue'
import Operator from '@/components/dashboard/Operator.vue'
import Dentist from '@/components/dashboard/Dentist.vue'

export default {
  name: 'ViewDashboard',

  components: {
    admin: Admin,
    operator: Operator,
    dentist: Dentist
  }
}
</script>
